// src/components/global/Table/ErrorStateRow.jsx
import React from 'react';
import { Box, Button, TableRow, TableCell, Typography } from '@mui/material';

const ErrorStateRow = ({ colSpan, isArabic, messageAr, messageEn, onRetry }) => {
    return (
        <TableRow>
            <TableCell
                colSpan={colSpan}
                align="center"
                sx={{ py: 4, color: 'error.main' }}
            >
                <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
                    <Typography variant="body1">
                        {isArabic ? messageAr : messageEn}
                    </Typography>
                    {onRetry && (
                        <Button
                            variant="outlined"
                            color="error"
                            onClick={onRetry}
                        >
                            {isArabic ? 'إعادة المحاولة' : 'Retry'}
                        </Button>
                    )}
                </Box>
            </TableCell>
        </TableRow>
    );
};

export default ErrorStateRow;
